import { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ReusableModal from '../common/Modal';

interface AccessRequestSuccessModalProps {
  open: boolean;
  onClose: () => void;
}

const AccessRequestSuccessModal: FC<AccessRequestSuccessModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <ReusableModal
      open={open}
      onClose={onClose}
      title="Access Request Sent"
      width={500}
      backgroundColor="rgba(55, 183, 125, 0.15)"
    >
      <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 400,
            color: 'text.secondary',
            textAlign: 'center',
          }}
        >
          Your request for menu access has been successfully sent to UrbanPiper.
          Once approved please push your menu from your POS for successful
          integration
        </Typography>

        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            width: '100%',
            textTransform: 'none',
            borderRadius: '6px',
            bgcolor: 'rgba(55, 183, 125, 1)',
            '&:hover': {
              bgcolor: 'rgba(45, 163, 105, 1)',
            },
            boxShadow: 'none',
          }}
        >
          Got It
        </Button>
      </Box>
    </ReusableModal>
  );
};

export default AccessRequestSuccessModal;
